import { ConfigurationShelfSampleTypeAssignmentResponse } from '@/modules/configurationModule/detail/automation/grossing-shelf/sample-type-and-shelf/services/configuration-shelf-sample-type-assignment/configuration-shelf-sample-type-assignment.dto'

export interface ConfigurationAutomationGrossingShelfSampleTypeAndShelfModalState {
    shelfSampleTypeAssignment: Partial<ConfigurationShelfSampleTypeAssignmentResponse>
}
export const initialConfigurationAutomationGrossingShelfSampleTypeAndShelfModalState =
    (): ConfigurationAutomationGrossingShelfSampleTypeAndShelfModalState => ({
        shelfSampleTypeAssignment: {}
    })
